import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { CartProvider } from "@/lib/cart";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CartDrawer } from "@/components/site/CartDrawer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Apply from "@/pages/Apply";
import ApplicationView from "@/pages/ApplicationView";
import MyApplications from "@/pages/MyApplications";
import Products from "@/pages/Products";
import Checkout from "@/pages/Checkout";
import OrderView from "@/pages/OrderView";
import MyOrders from "@/pages/MyOrders";
import Contact from "@/pages/Contact";
import Policy from "@/pages/Policy";
import Admin from "@/pages/Admin";
import Packages from "@/pages/Packages";
import DistributorRegister from "@/pages/DistributorRegister";
import MemberLogin from "@/pages/MemberLogin";
import Member from "@/pages/Member";

const ScrollTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const ref = new URLSearchParams(search).get("ref");
    if (ref && /^BMID\d{6}$/i.test(ref)) localStorage.setItem("bmi_ref", ref.toUpperCase());
  }, [search]);
  return null;
};

const SiteLayout = () => (
  <div className="flex min-h-screen flex-col">
    <ScrollTop />
    <Header />
    <main className="flex-1"><Outlet /></main>
    <Footer />
    <CartDrawer />
  </div>
);

const AuthPage = ({ children }) => <div className="flex min-h-[70vh] items-center justify-center px-4 py-16">{children}</div>;

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <CartProvider>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/apply/:appId" element={<Apply />} />
              <Route path="/application/:id" element={<ApplicationView />} />
              <Route path="/my-applications" element={<MyApplications />} />
              <Route path="/products" element={<Products />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:id" element={<OrderView />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/distributor/register" element={<DistributorRegister />} />
              <Route path="/member/login" element={<MemberLogin />} />
              <Route path="/member" element={<Member />} />
              <Route path="/policies/:slug" element={<Policy />} />
              <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
              <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
            </Route>
            <Route path="/admin/*" element={<Admin />} />
          </Routes>
          <Toaster richColors position="top-center" />
        </CartProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}
